export default "__VITE_ASSET__FX01YTWk__"